import React, { useEffect, useState } from 'react';

import {
  headersPlanoTrabalho,
  valoresExibidosPlanoAcao,
} from './auxiliarPlanoTrabalho';
import BarraInferiorBotoes from '../../../../../components/BarraInferiorBotoes';
import BoxConteudo from '../../../../../components/BoxConteudo';
import CustomButton from '../../../../../components/CustomButton';
import CustomCol from '../../../../../components/CustomCol';
import CustomRow from '../../../../../components/CustomRow';
import Input from '../../../../../components/InputNew';
import Select from '../../../../../components/InputNew/Select';
import Checkbox from '../../../../../components/Inputs/Checkbox';
import Log from '../../../../../components/Log/Log';
import Modal from '../../../../../components/Modal';
import Tabela from '../../../../../components/Tabela';
import WorkspaceBotoes from '../../../../../components/WorkspaceBotoes';
import WorkspaceFicha from '../../../../../components/WorkspaceFicha';
import { isHttpError } from '../../../../../services/httpClient';
import {
  getProdutoPorComponente,
  getProdutosByUsuario,
} from '../../../../../services/produtosDAF/produtosDafService';
import {
  createPlanoTrabalho,
  deleteDeletePlanoTrabalho,
  getPlanosTrabalhoPorPlanoAcao,
  updatePlanoTrabalho,
} from '../../../../../services/teds/tedsPlanoTrabalhoService';
import theme from '../../../../../theme';
import {
  formatarNumero,
  formatarValorFormatoDinheiro,
  formatDateSimp,
  formatoMoney,
  formatValorDinheiro,
} from '../../../../../utils/functions';
import {
  swalAttention,
  swalAtualizacao,
  swalDelete,
  swalDeleteConfirm,
  swalErro,
  swalSave,
} from '../../../../../utils/swal';

interface Props {
  novoRegistro: boolean;
  componente: number;
  idPlanoAcao: number;
  planoAcaoLabel: string;
}

type FormTedPlanoTrabalhoType = {
  [key: string]: string | number | boolean | null;
  id: number;
  tedPlanoAcaoId: number;
  produtoDafId: number;
  numeroItem: number;
  embalagemFator: string;
  qtdAdministrativa: string;
  qtdEstrategico: string;
  qtdJudicial: string;
  qtdOutro: string;
  qtdTotal: string;
  embalagemTotal: string;
  dataPrevista: string;

  valorUnitHomologado: string;
  valorReequilibrioBin: boolean;
  valorUnitReequilibrio: string | null;
  valorTotal: string;

  observacoes: string;
};

export const TedPlanoTrabalho: React.FC<Props> = ({
  novoRegistro,
  componente,
  idPlanoAcao,
  planoAcaoLabel,
}) => {
  const componenteLabel: Record<number, { label: string }> = {
    1: { label: 'basico' },
    2: { label: 'especializado' },
    3: { label: 'estrategico' },
  };

  //////STATES
  const [showModalPlanoTrabalho, setShowModalPlanoTrabalho] = useState(false);
  const [logDataPlanoTrabalho, setLogDataPlanoTrabalho] = useState<any>();
  const [planoTrabalhoId, setPlanoTrabalhoId] = useState('');
  const [updatingPlanoTrabalho, setUpdatingPlanoTrabalho] = useState(false);
  const [formPlanoTrabalho, setFormPlanoTrabalho] =
    useState<FormTedPlanoTrabalhoType>({
      id: 0,
      tedPlanoAcaoId: idPlanoAcao,
      produtoDafId: 0,
      numeroItem: 0,
      embalagemFator: '',
      qtdAdministrativa: '',
      qtdEstrategico: '',
      qtdJudicial: '',
      qtdOutro: '',
      qtdTotal: '',
      embalagemTotal: '',
      dataPrevista: '',

      valorUnitHomologado: '',
      valorReequilibrioBin: false,
      valorUnitReequilibrio: null as string | null,
      valorTotal: '',

      observacoes: '',
    });

  //////FETCH DATA PLANO TRABALHO
  const [dataPlanosTrabalho, setDataPlanosTrabalho] = useState<any[]>([]);
  const fetchDataPlanoTrabalho = async () => {
    try {
      const planosDeTrabalho = await getPlanosTrabalhoPorPlanoAcao(
        String(idPlanoAcao),
      );

      setFormPlanoTrabalho((prev) => ({
        ...prev,
        tedPlanoAcaoId: idPlanoAcao,
      }));

      setDataPlanosTrabalho(planosDeTrabalho);
    } catch (error) {
      console.error('Erro ao obter dados', error);
    }
  };

  useEffect(() => {
    fetchDataPlanoTrabalho();
  }, []);

  //////FETCH DATA PRODUTOS
  const [produtoData, setProdutoData] = useState<
    { value: number; label: string }[]
  >([]);
  const fetchProdutos = async () => {
    try {
      const produtos = await getProdutosByUsuario();
      setProdutoData([
        { value: 0, label: 'Não informado' },
        ...produtos.map(
          (item: { id: number; produtoFarmaceutico: string }) => ({
            value: item.id,
            label: item.produtoFarmaceutico,
          }),
        ),
      ]);
    } catch (error) {
      console.error('Erro ao obter produtos:', error);
      setProdutoData([]);
    }
  };

  useEffect(() => {
    if (componente) {
      fetchProdutos();
    }
  }, [componente]);

  //////TABLE E OFFCANVAS
  const tableDataPlanoTrabalho =
    dataPlanosTrabalho
      ?.slice() // faz uma cópia para não mutar o array original
      .sort((a, b) => Number(a.numeroItem) - Number(b.numeroItem))
      .map((item) => {
        return {
          id: item.id,
          numeroItem: item.numeroItem,
          // numeroPa: item.tedPlanoAcao.numeroPa,
          dataPrevista: item.dataPrevista
            ? formatDateSimp(item.dataPrevista)
            : '',
          produtoDaf: item.produtoDAF.produtoFarmaceutico,
          qtdTotal: (
            <div style={{ textAlign: 'right' }}>
              {formatarNumero(item.qtdTotal)}
            </div>
          ),
          valorTotal: (
            <div style={{ textAlign: 'right' }}>
              {formatarValorFormatoDinheiro(item.valorTotal)}
            </div>
          ),
        };
      }) || [];

  //////FUNÇÕES HANDLE
  const handleClearFormPlanoTrabalho = () => {
    setFormPlanoTrabalho({
      id: 0,
      tedPlanoAcaoId: 0,
      produtoDafId: 0,
      numeroItem: 0,

      embalagemFator: '',
      qtdAdministrativa: '',
      qtdEstrategico: '',
      qtdJudicial: '',
      qtdOutro: '',
      qtdTotal: '',
      embalagemTotal: '',

      dataPrevista: '',

      valorUnitHomologado: '',
      valorReequilibrioBin: false,
      valorUnitReequilibrio: '',
      valorTotal: '',

      observacoes: '',
    });
    setLogDataPlanoTrabalho({
      id: 0,
      usuarioRegistro: '',
      usuarioAtualizacao: '',
      dataRegistro: '',
      dataAtualizacao: '',
      nEdicoes: 0,
    });
  };

  const handleShowModalPlanoTrabalho = () =>
    setShowModalPlanoTrabalho((prev) => !prev);

  const handleClickInserirNovoPlanoTrabalho = () => {
    handleClearFormPlanoTrabalho();
    setUpdatingPlanoTrabalho(false);
    handleShowModalPlanoTrabalho();
  };

  const handleRowClickPlanoTrabalho = (id: string) => {
    setPlanoTrabalhoId(id);
    setUpdatingPlanoTrabalho(true);
    setShowModalPlanoTrabalho(true);
    const itemSelecionado = dataPlanosTrabalho?.find((d) => d.id === id);

    if (itemSelecionado) {
      const formatDateLocal = (iso: string) => iso?.split('T')[0];
      setFormPlanoTrabalho({
        id: Number(itemSelecionado.id),
        tedPlanoAcaoId: Number(itemSelecionado.tedPlanoAcao.id),
        produtoDafId: Number(itemSelecionado.produtoDAF.id),
        numeroItem: itemSelecionado.numeroItem,
        embalagemFator: formatarNumero(itemSelecionado.embalagemFator),
        qtdAdministrativa: formatarNumero(itemSelecionado.qtdAdministrativa),
        qtdEstrategico: formatarNumero(itemSelecionado.qtdEstrategico),
        qtdJudicial: formatarNumero(itemSelecionado.qtdJudicial),
        qtdOutro: formatarNumero(itemSelecionado.qtdOutro),
        qtdTotal: '',
        embalagemTotal: '',
        dataPrevista: itemSelecionado.dataPrevista
          ? formatDateLocal(itemSelecionado.dataPrevista)
          : '',
        valorUnitHomologado: formatarValorFormatoDinheiro(
          itemSelecionado.valorUnitHomologado,
        ),
        valorReequilibrioBin:
          itemSelecionado.valorReequilibrioBin == 'S' ? true : false,
        valorUnitReequilibrio: formatarValorFormatoDinheiro(
          itemSelecionado.valorUnitReequilibrio,
        ),
        valorTotal: formatoMoney(
          Number(itemSelecionado.valorTotal ?? 0).toFixed(2),
        ),

        observacoes: itemSelecionado.observacoes,
      });

      setLogDataPlanoTrabalho({
        id: itemSelecionado.id,
        usuarioRegistro: itemSelecionado.usuarioRegistro?.nomeCompleto || '',
        usuarioAtualizacao:
          itemSelecionado.usuarioAtualizacao?.nomeCompleto || '',
        dataRegistro: itemSelecionado.dataRegistro,
        dataAtualizacao: itemSelecionado.dataUltimaAtualizacao,
        nEdicoes: itemSelecionado.nEdicoes,
      });
    }

    setTimeout(() => {
      handleChangePlanoTrabalho({
        target: {
          name: 'qtdAdministrativa', // pode ser qualquer campo que dispare recálculo
          type: 'text',
          value: itemSelecionado.qtdAdministrativa?.toString() ?? '0',
        },
      } as React.ChangeEvent<HTMLInputElement>);
    }, 0);
  };

  //////FUNÇÕES CRUD
  const handleChangePlanoTrabalho = (
    event: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>,
  ) => {
    const { name, type, value, checked } = event.target as HTMLInputElement;

    setFormPlanoTrabalho((prev) => {
      const newValue =
        type === 'checkbox'
          ? checked
          : name.startsWith('valor')
            ? formatoMoney(value)
            : name === 'embalagemFator' || name.startsWith('qtd')
              ? formatarNumero(value)
              : value;

      const camposQtd = [
        'qtdAdministrativa',
        'qtdEstrategico',
        'qtdJudicial',
        'qtdOutro',
      ];

      const novasQuantidades = {
        ...prev,
        [name]: newValue,
      };

      // Recalcular qtdTotal
      let qtdTotal = prev.qtdTotal;
      if (camposQtd.includes(name)) {
        const soma = camposQtd
          .map((campo) =>
            Number(String(novasQuantidades[campo] ?? '0').replace(/\./g, '')),
          )
          .reduce((acc, val) => acc + val, 0);

        qtdTotal = formatarNumero(soma.toString());
        novasQuantidades.qtdTotal = qtdTotal; // atualiza diretamente no objeto usado abaixo
      }

      // Recalcular valores
      const qtdTotalNumber = Number(
        (novasQuantidades.qtdTotal || '0').replace(/\./g, ''),
      );
      const valorUnitHomologadoNumber = Number(
        (novasQuantidades.valorUnitHomologado || '0')
          .replace(/\./g, '')
          .replace(',', '.'),
      );
      const valorUnitReequilibrioNumber = Number(
        (novasQuantidades.valorUnitReequilibrio || '0')
          .replace(/\./g, '')
          .replace(',', '.'),
      );

      const valorTotalCalculado = novasQuantidades.valorReequilibrioBin
        ? qtdTotalNumber * valorUnitReequilibrioNumber
        : qtdTotalNumber * valorUnitHomologadoNumber;

      // Recalcular embalagemTotal
      const embalagemFatorNumber = Number(
        (novasQuantidades.embalagemFator || '0').replace(/\./g, ''),
      );

      let embalagemTotal = '0';
      if (embalagemFatorNumber > 0) {
        const total = qtdTotalNumber / embalagemFatorNumber;
        embalagemTotal = formatarNumero(Math.floor(total).toString()); // ou usar `.toFixed(0)` se quiser string decimal
      }

      return {
        ...novasQuantidades,
        qtdTotal,
        valorTotal: formatoMoney(valorTotalCalculado.toFixed(2)),
        embalagemTotal,
      };
    });
  };

  const handleCreatePlanoTrabalho = async () => {
    try {
      if (!validateFormPlanoTrabalho(formPlanoTrabalho))
        throw new Error('Formulário inválido.');

      const adjustedForm =
        adjustFormPlanoTrabalhoBeforeSubmit(formPlanoTrabalho);

      await createPlanoTrabalho(adjustedForm);

      swalSave();
      fetchDataPlanoTrabalho();
      setTimeout(() => handleShowModalPlanoTrabalho(), 2000);
    } catch (err: any) {
      if (isHttpError(err)) swalErro(err.response?.data.message);
      console.error('Erro ao salvar registro:', err);
    }
  };

  const handleUpdatePlanoTrabalho = async () => {
    try {
      if (!validateFormPlanoTrabalho(formPlanoTrabalho))
        throw new Error('Formulário inválido.');

      const adjustedForm =
        adjustFormPlanoTrabalhoBeforeSubmit(formPlanoTrabalho);

      const response = await updatePlanoTrabalho(planoTrabalhoId, adjustedForm);

      swalAtualizacao('Sucesso', response.data.message);
      fetchDataPlanoTrabalho();
      setTimeout(() => handleShowModalPlanoTrabalho(), 2000);
    } catch (err: any) {
      if (isHttpError(err)) swalErro(err.response?.data.message);
      console.error('Erro ao atualizar registro:', err);
    }
  };

  const handleDeletePlanoTrabalho = async () => {
    const result = await swalDelete();
    if (!result) return swalErro('A operação falhou.');
    try {
      await deleteDeletePlanoTrabalho(planoTrabalhoId);
      swalDeleteConfirm();
      fetchDataPlanoTrabalho();
      setTimeout(() => handleShowModalPlanoTrabalho(), 2000);
    } catch (err: any) {
      if (isHttpError(err)) swalErro(err.response?.data.message);
      console.error('Erro ao excluir registro:', err);
    }
  };

  //////OUTRAS FUNÇÕES
  const validateFormPlanoTrabalho = (form: any) => {
    const errors = [];

    if (form.produtoDafId === 0) {
      errors.push('<b>Produto Farmacêutico</b> é obrigatório.');
    }

    const numeroItemExists = dataPlanosTrabalho.some(
      (item) =>
        Number(item.numeroItem) === Number(form.numeroItem) &&
        item.id !== form.id,
    );

    if (numeroItemExists) {
      errors.push(
        'O <b>Nº do Item</b> informado já existe neste Plano de Ação.',
      );
    }

    if (form.embalagemFator === '') {
      errors.push('<b>Qtd ADMINISTRATIVA</b> é obrigatório.');
    }

    if (form.qtdAdministrativa === '') {
      errors.push('<b>Qtd ADMINISTRATIVA</b> é obrigatório.');
    }

    if (form.qtdEstrategico === '') {
      errors.push('<b>Qtd ESTRATEGICO</b> é obrigatório.');
    }

    if (form.qtdJudicial === '') {
      errors.push('<b>Qtd JUDICIAL</b> é obrigatório.');
    }

    if (form.qtdOutro === '') {
      errors.push('<b>Qtd OUTRO</b> é obrigatório.');
    }

    if (form.valorUnitHomologado === '') {
      errors.push('<b>Valor Unitário Homologado</b> é obrigatório.');
    }

    if (errors.length > 0) {
      swalAttention(errors.join('<br>'));
      return false;
    }
    return true;
  };

  const adjustFormPlanoTrabalhoBeforeSubmit = (form: any) => {
    const adjustedForm = {
      ...form,
      tedPlanoAcaoId: Number(idPlanoAcao),
      produtoDafId: Number(form.produtoDafId),
      numeroItem: Number(form.numeroItem),
      embalagemFator: Number(form.embalagemFator.replace(/\./g, '')),
      qtdAdministrativa: Number(form.qtdAdministrativa.replace(/\./g, '')),
      qtdEstrategico: Number(form.qtdEstrategico.replace(/\./g, '')),
      qtdJudicial: Number(form.qtdJudicial.replace(/\./g, '')),
      qtdOutro: Number(form.qtdOutro.replace(/\./g, '')),
      valorUnitHomologado: Number(
        form.valorUnitHomologado.replace(/\./g, '').replace(',', '.'),
      ),
      valorUnitReequilibrio: form?.valorReequilibrioBin
        ? Number(
            form.valorUnitReequilibrio.replace(/\./g, '').replace(',', '.'),
          )
        : null,
      valorReequilibrioBin: form?.valorReequilibrioBin ? 'S' : 'N',

      //Observações
      observacoes:
        form.observacoes === ''
          ? 'Sem observações específicas.'
          : form.observacoes,
    };

    // Remover campos não desejados
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { embalagemTotal, qtdTotal, valorTotal, ...cleanForm } = adjustedForm;
    return cleanForm;
  };

  const [
    isValorUnitarioHomologadoReadOnly,
    setIsValorUnitarioHomologadoReadOnly,
  ] = useState(false);
  useEffect(() => {
    if (formPlanoTrabalho.valorReequilibrioBin === false) {
      setIsValorUnitarioHomologadoReadOnly(true);
      setFormPlanoTrabalho((prev) => ({
        ...prev,
        valorUnitReequilibrio: null,
      }));
    } else {
      setIsValorUnitarioHomologadoReadOnly(false);
    }
  }, [formPlanoTrabalho.valorReequilibrioBin]);

  return (
    <BoxConteudo boxTitulo="Plano de Trabalho">
      <CustomRow>
        <CustomCol width="100%">
          <Tabela
            headers={headersPlanoTrabalho}
            dataTable={tableDataPlanoTrabalho}
            displayValues={valoresExibidosPlanoAcao}
            onRowClick={handleRowClickPlanoTrabalho}
            dataOffCanvas={[]}
            botaoAbrirOffCanvas={false}
            showPagination={false}
            mostrarBotaoCopiar={false}
            noOffCanvasTable={true}
          />
        </CustomCol>
      </CustomRow>
      <CustomCol className="d-flex justify-content-end">
        <CustomButton
          label="Novo Registro"
          bgColor={theme.colors.botaoAcao.azul}
          textColor={theme.colors.white}
          onClick={() => {
            setUpdatingPlanoTrabalho(false);
            handleClickInserirNovoPlanoTrabalho();
          }}
          disabled={!novoRegistro}
        />
      </CustomCol>

      {/* Modal/*/}
      <Modal
        tituloModal="Plano de Trabalho"
        open={showModalPlanoTrabalho}
        onHide={handleShowModalPlanoTrabalho}
      >
        <WorkspaceFicha>
          <Log
            {...logDataPlanoTrabalho}
            entity="TB_TED_PLANO_TRABALHO"
            id={Number(formPlanoTrabalho.id)}
          />

          <BoxConteudo boxTitulo="Identificação do Plano de Trabalho">
            {/* Plano de Trabalho */}
            <CustomRow style={{ marginTop: '10px' }}>
              <CustomCol width="150px">
                <Input
                  id="tedPlanoAcaoId"
                  name="tedPlanoAcaoId"
                  value={
                    formPlanoTrabalho.tedPlanoAcaoId === 0
                      ? idPlanoAcao
                      : formPlanoTrabalho.tedPlanoAcaoId
                  }
                  label="ID Plano Ação"
                  // eslint-disable-next-line @typescript-eslint/no-empty-function
                  onChange={() => {}}
                  readonly
                />
              </CustomCol>
              <CustomCol width="300px">
                <Input
                  id="tedPlanoAcaoId"
                  name="tedPlanoAcaoId"
                  value={planoAcaoLabel}
                  label="Plano de Ação"
                  // eslint-disable-next-line @typescript-eslint/no-empty-function
                  onChange={() => {}}
                  readonly
                />
              </CustomCol>
              <CustomCol width="150px">
                <Input
                  id="numeroItem"
                  name="numeroItem"
                  value={formPlanoTrabalho.numeroItem}
                  label="Nº Item"
                  onChange={handleChangePlanoTrabalho}
                />
              </CustomCol>
              <CustomCol></CustomCol>
            </CustomRow>

            {/* Produto DAF */}
            <CustomRow>
              <CustomCol width="150px">
                <Input
                  id="produtoDafId"
                  name="produtoDafId"
                  value={
                    formPlanoTrabalho.produtoDafId === 0
                      ? ''
                      : formPlanoTrabalho.produtoDafId
                  }
                  label="ID Produto"
                  // eslint-disable-next-line @typescript-eslint/no-empty-function
                  onChange={() => {}}
                  readonly
                />
              </CustomCol>
              <CustomCol>
                <Select
                  name="produtoDafId"
                  value={formPlanoTrabalho.produtoDafId}
                  label="Produto Farmacêutico"
                  options={produtoData}
                  onChange={handleChangePlanoTrabalho}
                  required
                  disabled={updatingPlanoTrabalho}
                />
              </CustomCol>
            </CustomRow>

            {/* Quantidade e Valores da ARP */}
            <CustomRow>
              <CustomCol width="200px">
                <Input
                  name="embalagemFator"
                  label="Fator Embalagem"
                  value={formPlanoTrabalho.embalagemFator}
                  id="embalagemFator"
                  onChange={handleChangePlanoTrabalho}
                  textAlign="right"
                  required
                />
              </CustomCol>
              <CustomCol width="200px">
                <Input
                  name="qtdAdministrativa"
                  label="Qtd Administrativa"
                  value={formPlanoTrabalho.qtdAdministrativa}
                  id="qtdAdministrativa"
                  onChange={handleChangePlanoTrabalho}
                  textAlign="right"
                  required
                />
              </CustomCol>
              <CustomCol width="200px">
                <Input
                  name="qtdEstrategico"
                  label="Qtd Estratégico"
                  value={formPlanoTrabalho.qtdEstrategico}
                  id="qtdEstrategico"
                  onChange={handleChangePlanoTrabalho}
                  textAlign="right"
                  required
                />
              </CustomCol>
              <CustomCol width="200px">
                <Input
                  name="qtdJudicial"
                  label="Qtd Judicial"
                  value={formPlanoTrabalho.qtdJudicial}
                  id="qtdJudicial"
                  onChange={handleChangePlanoTrabalho}
                  textAlign="right"
                  required
                />
              </CustomCol>
              <CustomCol width="180px">
                <Input
                  name="qtdOutro"
                  label="Qtd Outro"
                  value={formPlanoTrabalho.qtdOutro}
                  id="qtdOutro"
                  onChange={handleChangePlanoTrabalho}
                  textAlign="right"
                  required
                />
              </CustomCol>
              <CustomCol>
                <Input
                  name="qtdTotal"
                  label="Qtd Total"
                  value={formPlanoTrabalho.qtdTotal}
                  id="qtdTotal"
                  onChange={handleChangePlanoTrabalho}
                  textAlign="right"
                  readonly
                />
              </CustomCol>
              <CustomCol width="150px">
                <Input
                  name="embalagemTotal"
                  label="Total Embalagens"
                  value={formPlanoTrabalho.embalagemTotal}
                  id="embalagemTotal"
                  onChange={handleChangePlanoTrabalho}
                  textAlign="right"
                  readonly
                />
              </CustomCol>
            </CustomRow>

            {/* Valores */}
            <CustomRow>
              <CustomCol width="200px">
                <Input
                  id="dataPrevista"
                  name="dataPrevista"
                  label="Data de Entrega Prevista"
                  value={formPlanoTrabalho.dataPrevista}
                  onChange={handleChangePlanoTrabalho}
                  type="date"
                  required
                />
              </CustomCol>

              <CustomCol width="200px">
                <Input
                  name="valorUnitHomologado"
                  label="Valor Unitário Homologado"
                  value={formPlanoTrabalho.valorUnitHomologado}
                  id="valorUnitHomologado"
                  onChange={handleChangePlanoTrabalho}
                  style={{ textAlign: 'right' }}
                  required
                />
              </CustomCol>
              <CustomCol width="250px">
                <div
                  style={{
                    marginBottom: '5px',
                    paddingTop: '0px',
                    color: theme.colors.botaoConfirmar,
                  }}
                >
                  Valor Unitário Reequilíbrio
                </div>
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    gap: '2px',
                  }}
                >
                  <Checkbox
                    name="valorReequilibrioBin"
                    label=""
                    checked={formPlanoTrabalho.valorReequilibrioBin}
                    style={{ fontSize: '1.5rem' }}
                    onChange={handleChangePlanoTrabalho}
                  ></Checkbox>
                  <Input
                    name="valorUnitReequilibrio"
                    label=""
                    value={
                      formPlanoTrabalho.valorReequilibrioBin
                        ? formPlanoTrabalho.valorUnitReequilibrio
                          ? formatValorDinheiro(
                              formPlanoTrabalho.valorUnitReequilibrio,
                            )
                          : ''
                        : ''
                    }
                    id="valorUnitReequilibrio"
                    onChange={handleChangePlanoTrabalho}
                    readonly={isValorUnitarioHomologadoReadOnly}
                    style={{ textAlign: 'right' }}
                  />
                </div>
              </CustomCol>
              <CustomCol width="250px">
                <Input
                  name="valorTotal"
                  label="Valor Total R$"
                  value={formPlanoTrabalho.valorTotal}
                  id="valorTotal"
                  onChange={handleChangePlanoTrabalho}
                  textAlign="right"
                  readonly
                />
              </CustomCol>
              <CustomCol></CustomCol>
            </CustomRow>

            {/* Observações */}
            <CustomRow>
              <CustomCol width="100%">
                <Input
                  id="observacoes"
                  name="observacoes"
                  value={formPlanoTrabalho.observacoes}
                  label="Observações"
                  type="textarea"
                  onChange={handleChangePlanoTrabalho}
                  linhas={3}
                />
              </CustomCol>
            </CustomRow>
          </BoxConteudo>

          <BarraInferiorBotoes>
            {updatingPlanoTrabalho ? (
              <WorkspaceBotoes
                delete
                // deleteDisabled={btDisable}
                onClickDelete={handleDeletePlanoTrabalho}
                save
                // saveDisabled={btDisable}
                onClickSave={handleUpdatePlanoTrabalho}
              />
            ) : (
              <WorkspaceBotoes
                inserir
                // inserirDisabled={btDisable}
                onClickInserir={handleCreatePlanoTrabalho}
              />
            )}
          </BarraInferiorBotoes>
        </WorkspaceFicha>
      </Modal>
    </BoxConteudo>
  );
};
